import React, { useState } from 'react';
import styled from 'styled-components';
import {
  AppCard,
  AppCheckbox,
  AppInput,
  AppSingleSelect,
} from '@/layout/AppComponents';
import ReactDOMServer from 'react-dom/server';
import Translator from '../../../../components/helpers/Translator';
import colors from '../../../../../constants/colors';

export default function ModuleComsaEnvironmentalIndustrialControlCard(props) {
  const { filterApplicable, values, setFieldValue, description } = props;
  const [noYesOptions] = useState([
    {
      label: ReactDOMServer.renderToString(
        <Translator file="module-comsaEnvironmental" name="no" />
      ),
      value: 0,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator file="module-comsaEnvironmental" name="yes" />
      ),
      value: 1,
    },
  ]);

  if (filterApplicable && !values?.applicable) {
    return null;
  }

  return (
    <Container>
      <AppCheckbox
        title={
          values?.applicable
            ? ReactDOMServer.renderToString(
                <Translator
                  file="module-comsaEnvironmental"
                  name="no.applicable"
                />
              )
            : ReactDOMServer.renderToString(
                <Translator
                  file="module-comsaEnvironmental"
                  name="assign.as.applicable"
                />
              )
        }
        value={values?.applicable}
        className="d-inline-flex"
        onChange={(v) => setFieldValue('applicable', v)}
      />
      <AppCardContainer
        className="mb-2"
        bodyClassName="p-1"
        $applicable={values?.applicable}
      >
        <div className="info-block">
          <div className="line color mb-2">
            <div>
              <Translator file="module-comsaEnvironmental" name="description" />
              :
            </div>
            <div>
              <b>{description}</b>
            </div>
          </div>
        </div>
        <div className="info-block">
          <div className="line">
            <AppSingleSelect
              options={noYesOptions}
              title={ReactDOMServer.renderToString(
                <Translator
                  file="module-comsaEnvironmental"
                  name="contemplated"
                />
              )}
              value={values?.considered}
              onChange={(v) => setFieldValue('considered', v)}
              isClearable
            />
          </div>
          {values?.considered === 1 && (
            <div className="line">
              <AppInput
                title={ReactDOMServer.renderToString(
                  <Translator file="module-comsaEnvironmental" name="specify" />
                )}
                value={values?.consideredDescription}
                onChange={(v) => setFieldValue('consideredDescription', v)}
              />
            </div>
          )}
        </div>
        <div className="info-block">
          <div className="line">
            <AppSingleSelect
              options={noYesOptions}
              title={ReactDOMServer.renderToString(
                <Translator
                  file="module-comsaEnvironmental"
                  name="legal-requirement-dia-customer"
                />
              )}
              value={values?.legalRequisite}
              onChange={(v) => setFieldValue('legalRequisite', v)}
              isClearable
            />
          </div>
          <div className="line">
            <AppInput
              title={ReactDOMServer.renderToString(
                <Translator file="module-comsaEnvironmental" name="indicate" />
              )}
              value={values?.legalRequisiteDescription}
              onChange={(v) => setFieldValue('legalRequisiteDescription', v)}
            />
          </div>
        </div>
      </AppCardContainer>
    </Container>
  );
}

const Container = styled.div`
  display: grid;
  grid-template-columns: 24px 1fr;
`;

const AppCardContainer = styled(AppCard)`
  border: 2px solid ${(props) => (props.$applicable ? '#28a745' : '#fff')};
  .info-block {
    display: flex;
    flex-direction: column;
    gap: 10px;
    @media (min-width: 768px) {
      flex-direction: row;
    }
    .line {
      flex: 1 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      &.color {
        color: ${colors.primaryLight};
      }
    }
  }
`;
